import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "../../../../.MODULS/UCAT_EXAM_MODUL/Assests/download-min.svg";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
// import { listPracticeTest } from "../../../../Redux/Slices/PracticeTest/ListPracticeTestSlice";
import CircularProgress from "@mui/material/CircularProgress";
import { clearlistStudentExam } from "../../../../Redux/Slices/StudentExam/ListStudentExamSlice";
import { UcatLayout, UcatModal } from "../../Components/Shared";
import useNavigationBlocker from "../../../../Hooks/useNavigationBlocker";
import QuestionMarkIcon from "../../Assests/green_question_mark.png"

/* ================== STATIC DATA ================== */
// export const UCAT_WELCOME_DATA = {
//   examBrand: {
//     short: "UCAT",
//     full: "University Clinical Aptitude Test",
//   },
//   content: {
//     title: "Welcome to the UCAT Practice Questions",

//   },
// };

/* ================== COMPONENT ================== */
interface UcatPracticeTestWelcomeScreenProps {
  examData?: {
    id: number;
    name: string;
    description: string;
  };
}

// props are optional
export const UcatPracticeTestWelcomeScreen: React.FC<UcatPracticeTestWelcomeScreenProps> = ({ examData: propsExamData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  useNavigationBlocker(true);
  const examDataFromState = location.state;

  // Persist exam_id and exam data to handle reloads
  useEffect(() => {
    if (examDataFromState) {
      const id = typeof examDataFromState === 'object' ? examDataFromState?.id : examDataFromState;
      if (id) sessionStorage.setItem("ucat_exam_id", String(id));
      if (typeof examDataFromState === 'object') {
        sessionStorage.setItem("ucat_exam_data", JSON.stringify(examDataFromState));
      }
    }
  }, [examDataFromState]);

  const persistedExamId = sessionStorage.getItem("ucat_exam_id");
  const persistedExamDataStr = sessionStorage.getItem("ucat_exam_data");
  const persistedExamData = persistedExamDataStr ? JSON.parse(persistedExamDataStr) : null;

  const exam_id = (typeof examDataFromState === 'object' ? examDataFromState?.id : examDataFromState) || persistedExamId;
  const [openDialog, setOpenDialog] = useState(false);

  // Get data from Redux
  // const { data: ListPracticeTestSlice, isLoading } = useAppSelector(
  //   (state) => state.ListPracticeTestSlice
  // );

  // console.log("SEE here:", ListPracticeTestSlice, isLoading, useAppSelector((state) => state.ListPracticeTestSlice))

  // Fetch exam instruction data on mount
  // useEffect(() => {
  //   dispatch(clearlistStudentExam()); // Clear stale student exam data
  //   if (exam_id) {
  //     dispatch(listPracticeTest());
  //   }
  // }, [dispatch, exam_id]);

  // const examData = ListPracticeTestSlice?.data;
  const { data: listPracticeExams } = useAppSelector(
    (state) => state.ListPracticeTestSlice
  );

  const examData = propsExamData ||
    (typeof examDataFromState === 'object' ? examDataFromState : null) ||
    persistedExamData ||
    (Array.isArray(listPracticeExams?.data)
      ? listPracticeExams?.data.find((exam: any) => exam.id === Number(exam_id))
      : null);

  console.log("examData", examData)

  const handleNext = () => {
    setOpenDialog(true);
  };

  const handleConfirmYes = () => {
    setOpenDialog(false);
    navigate("/ucat_test_instructions", {
      state: {
        id: exam_id,
        name: examData?.name,
        instruction: examData?.instruction,
        student_test_id: examData?.retake_id || examData?.student_test_id,
      },
    });
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    // Only handle Alt key combinations
    if (e.altKey) {
      const key = e.key.toLowerCase();

      // Prevent default browser behavior
      e.preventDefault();

      if (openDialog) {
        // Dialog context
        switch (key) {
          case 'y':
            handleConfirmYes();
            break;
          case 'n':
            handleConfirmNo();
            break;
        }
      } else {
        // Main screen context
        switch (key) {
          case 'e':
            // End exam action
            navigate("/practicetest");
            break;
          case 'n':
            handleNext();
            break;
        }
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup on unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [openDialog]); // Re-bind when dialog state changes

  const handleConfirmNo = () => {
    setOpenDialog(false);
  };
  // Show loading state while fetching data
  if (!exam_id) {
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <CircularProgress />
      </div>
    );
  }

  // Get the first section name or use exam name as header title
  // const headerTitle = examData?.questions_by_type?.[0]?.question_type_name || examData?.exam_name || "UCAT Practice";
  // const subTitle = examData?.exam_name || "";
  // get alternative data from props
  const headerTitle = examData?.name || "UCAT Practice";
  const subTitle = examData?.description || "";

  console.log("exam data")
  // console.log("headerTitle22", headerTitle);
  // console.log("subTitle22", subTitle);

  return (
    <UcatLayout
      headerTitle={headerTitle}
      showToolbar={true}
      footerProps={{
        onEndExam: () => navigate("/practicetest"),
        onNext: handleNext,
        leftButtonText: "End Exam",
        rightButtonText: "Next"
      }}
    >
      {/* ================= CONTENT ================= */}
      <div className="flex-1 overflow-y-auto ucat-scrollbar min-h-0">
        <div className="ucat-module font-[15px] max-w-[100%] mx-auto px-4 py-4">
          {/* Logo */}
          <div className="flex justify-end mb-3">
            <Logo className="w-[456px] h-auto" />
          </div>

          {/* Text Content */}
          <div className="space-y-4 text-[14px] text-black max-w-full">
            <div>
              <h1 className="flex text-[16px]  font-[700] mb-3">
                {/* {examData?.name} */}
                Welcome to UCAT Practice Questions
              </h1>
              <p className="text-[15px] font-[700]">
                {examData?.name}
              </p>
            </div>

            <p className="text-[15px]">
              Use this question bank to familiarise yourself with the types of questions in this subtest.
              <br /> <br />
              <i style={{ fontSize: "inherit" }}>Before using this question bank, we recommend you work through the relevant question tutorial as it includes in-depth tips and strategies on how to approach and answer each of the different question types within this subtest. Question Tutorials are available on the Preparation Resources section of the website.</i>
              <br /> <br />
              Each question bank contains a large number of questions (split into sections) that you may wish to attempt over several practice sessions.
              <br /> <br />
              The 'Navigator' function at the bottom right of the screen allows you to navigate between questions and sections within the bank.
              <br /> <br />
              Your progress through the question bank is not retained for future visits. It is therefore advisable to make a note of which questions you have attempted.
              <br /> <br />
              As you progress through each question, you can click 'Explain Answer' at the top left of the screen to check the correct answer and read the answer rationale.
              <br /> <br />
              An alternative way to check your answers is to use the 'Navigator' to skip to the final question, then click <b style={{ fontSize: "inherit" }}>Next (N)</b> to proceed to the Review Screen. The Review Screen will show which questions are answered incorrectly. You may click on a question number to return directly to its location in the bank, where you can check the correct answer and rationale by clicking ‘Explain Answer’ at the top of the screen.
              <br /> <br />
              Click the <b style={{ fontSize: "inherit" }}>Next (N)</b> button when you are ready to begin.


            </p>

            {/* {UCAT_WELCOME_DATA.content.paragraphs.map((text, index) => (
            <p key={index} className="text-[15px] font-[400]">{text}</p>
          ))} */}
          </div>
        </div>
      </div>

      {/* ================= CONFIRMATION DIALOG ================= */}
      {/* refactr UCATDialog later */}
      {openDialog && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Custom Modal matching the reference image */}
          <div
            className="w-[550px] bg-[#006DAA] border border-white shadow-lg"
          // style={{ transform: `translate(${position.x}px, ${position.y}px)` }}
          >
            {/* Header */}
            <div
              className="text-white font-normal text-[16px] px-4 py-3 border-b border-white cursor-move select-none"
              style={{ marginBottom: "16px" }}
            // onMouseDown={handleDragStart}
            >
              Ready to Begin Exam
            </div>

            {/* Content */}
            <div className="px-5 pb-3">
              <div className="flex items-start gap-3">
                {/* Green Question Mark Icon */}
                <div className="flex-shrink-0">
                  <div className="w-[32px] h-[32px] rounded-full bg-[#669900] border border-[#7BB800] flex items-center justify-center shadow-md">
                    <img src={QuestionMarkIcon} style={{ height: "100%", width: "100%" }} alt="?" />
                  </div>
                </div>


                <p className="text-white text-[16px] leading-snug pt-1">
                  If you are ready to begin the exam, select the Yes button.
                  Otherwise, select the No button to return to the previous screen.
                </p>
              </div>

              {/* Buttons */}
              <div className="flex justify-center gap-3 mt-3">
                <button
                  onClick={handleConfirmYes}
                  className="w-[50px] h-[28px] bg-[#006DAA] text-white text-[16px] font-[400] border border-white hover:color-[#FFFF00] transition-colors leading-none"
                >
                  <span className="underline" style={{ fontSize: "16px" }}>Y</span>es
                </button>

                <button
                  onClick={handleConfirmNo}
                  className="w-[50px] h-[28px] bg-[#006DAA] text-white text-[16px] font-[400] border border-white hover:color-[#FFFF00] transition-colors leading-none"
                >
                  <span className="underline" style={{ fontSize: "16px" }}>N</span>o
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </UcatLayout>
  );
};
